import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import StreamingPage from './app/StreamingPage';
import AppNav from './components/AppNav';
import './App.css';

const App = () => {
  return (
    <div className="app-container">
      <BrowserRouter>
        <Routes>
          <Route path="/stream/:shareCode?" element={<StreamingPage />} />
        </Routes>
        <AppNav />
      </BrowserRouter>
    </div>
  );
};

export default App; 